#import "../fragments/managed-meeting-fragment.graphql"

query GetAssignments($meetingId: ID!) {
    meeting(id: $meetingId) {
        ...ManagedMeetingFragment
    }
}
